import { render, staticRenderFns } from "./CourseGauge.vue?vue&type=template&id=1764f169&scoped=true&"
import script from "./CourseGauge.vue?vue&type=script&lang=js&"
export * from "./CourseGauge.vue?vue&type=script&lang=js&"
import style0 from "./CourseGauge.vue?vue&type=style&index=0&id=1764f169&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1764f169",
  null
  
)

export default component.exports